
import { lazy } from 'react';

export const LazyCategories = lazy(() => 
  import('@/pages/Categories').then(module => ({ default: module.Categories }))
);
